import React from 'react';
import RedirectToLegacyRouting from '@atlassian/jira-spa-apps-common/src/redirect/legacy-routing';

/** This exists to be used as a route since the redirect as a route and redirect as a component
 * have different props, and flow complains. */
// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => <RedirectToLegacyRouting />;
